import axios from 'axios';

import authHeader from './authHeader';
import { Config } from '@/config';

class SiteService {
  async get() {
    try {
      const response = await axios.get(`${Config.HOST.URL}${Config.API_ROUTES.SITES.GET_ALL}`, { headers: authHeader() });
      if (response.data !== undefined) {
        return response.data;
      }
    } catch (error) {
      throw error.message;
    }
  }

  async getById(siteId) {
    try {
      const response = await axios.get(`${Config.HOST.URL}${Config.API_ROUTES.SITES.GET_ONE.replace(':site_id', siteId)}`, { headers: authHeader() });
      if (response.data !== undefined) {
        return response.data;
      }
    } catch (error) {
      throw error.message;
    }
  }

  async getNavigationSites(lat, lng) {
    try {
      const response = await axios.post(`${Config.HOST.URL}${Config.API_ROUTES.NAVIGATION.GET_SITES}`, { lat, lng }, { headers: authHeader() });
      if (response.data !== undefined) {
        return response.data;
      }
    } catch (error) {
      throw error.message;
    }
  }

  async getParkings(siteId) {
    try {
      const response = await axios.get(`${Config.HOST.URL}${Config.API_ROUTES.SITES.GET_PARKINGS.replace(':site_id', siteId)}`, { headers: authHeader() });
      if (response.data !== undefined) {
        return response.data;
      }
    } catch (error) {
      throw error.message;
    }
  }

  async getDestinations(siteId) {
    try {
      const response = await axios.get(`${Config.HOST.URL}${Config.API_ROUTES.SITES.GET_DESTINATIONS.replace(':site_id', siteId)}`, { headers: authHeader() });
      if (response.data !== undefined) {
        return response.data;
      }
    } catch (error) {
      throw error.message;
    }
  }

  async getParkingsAttendance(parkingsIds) {
    try {
      const response = await axios.get(`${Config.HOST.URL}${Config.API_ROUTES.PARKINGS.GET_ALL}?parking_ids=${parkingsIds.join(',')}`, { headers: authHeader() });
      if (response.data !== undefined) {
        return response.data;
      }
    } catch (error) {
      throw error.message;
    }
  }

  async getNavigationParkings(destination_id, location) {
    try {
      let params = { destination_id, get_full_walking_distance: true, filters: { area: { type: 'normal' } } };
      if (location !== undefined) {
        params.location = location;
      }
      const response = await axios.post(`${Config.HOST.URL}${Config.API_ROUTES.NAVIGATION.GET_PARKINGS}`, params, { headers: authHeader() });
      if (response.data !== undefined) {
        return response.data.parkings;
      }
    } catch (error) {
      throw error.message;
    }
  }

  async getNavigationSpot(contract, destination_id, parking_id, location) {
    try {
      let params = { contract, destination_id, parking_id, get_full_walking_distance: true, filters: { area: { type: 'normal' } } };
      if (location !== undefined) {
        params.location = location;
      }
      const response = await axios.post(`${Config.HOST.URL}${Config.API_ROUTES.NAVIGATION.GET_BEST_AREA}`, params, { headers: authHeader() });
      if (response.data !== undefined) {
        return response.data;
      }
    } catch (error) {
      throw error.message;
    }
  }
}

export default new SiteService();
